import IconText from './IconText'

export default IconText
